var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangleExclaimationRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.67657L14.3202 12.5963H1.67982L8 1.67657ZM0.227771 11.757C-0.418516 12.8733 0.387244 14.275 1.67982 14.275H14.3202C15.6128 14.275 16.4185 12.8733 15.7722 11.757L9.45205 0.837235C8.80576 -0.279078 7.19424 -0.279078 6.54795 0.837235L0.227771 11.757ZM7.16067 5.88163V7.5603C7.16067 8.02193 7.53837 8.39963 8 8.39963C8.46163 8.39963 8.83933 8.02193 8.83933 7.5603V5.88163C8.83933 5.42 8.46163 5.0423 8 5.0423C7.53837 5.0423 7.16067 5.42 7.16067 5.88163ZM7.16067 10.0783H8.83933V11.757H7.16067V10.0783Z",
    fill: "#D74837"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleExclaimationRegular);
export default __webpack_public_path__ + "97131/static/media/triangle-exclaimation-regular.8599474c0ade6a98908673ddddf74eae.svg";
export { ForwardRef as ReactComponent };